export const format = (v: number | undefined, minDigits = 2, maxDigits = 2) =>
    v
        ? v.toLocaleString(undefined, {
              minimumFractionDigits: minDigits,
              maximumFractionDigits: maxDigits,
          })
        : '-'
